import styled from "styled-components";

export const DeliveryProviderSelectorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;

  .provider-item {
    display: flex !important;
    align-items: stretch;
    padding: 0.75rem;
    border: 1px solid var(--color-border, #e5e7eb);
    border-radius: 0.5rem;
    cursor: pointer;
    transition: border-color 0.15s ease;

    &.selected {
      border-color: var(--color-primary, #6366f1);
      background: var(--color-primary-light, #eef2ff);
    }

    .provider-radio {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      padding-right: 0.75rem;

      input[type="radio"] {
        margin: 0;
      }
    }

    .provider-body {
      flex: 1;
      display: flex;
      align-items: center;
      gap: 0.75rem;
      min-width: 0;
    }

    .provider-icon {
      width: 40px;
      height: 40px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .provider-details {
      flex: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 0.35rem 0.5rem;
      min-width: 0;
    }

    .provider-name {
      font-weight: 600;
      margin: 0;
      line-height: 1.25;
    }

    .provider-time {
      font-size: 0.75rem;
      color: var(--color-text-secondary, #6b7280);
      margin: 0;
      line-height: 1.25;

      &::before {
        content: "·";
        margin-right: 0.35rem;
        color: var(--color-text-secondary, #9ca3af);
      }
    }

    .provider-price {
      font-weight: 600;
      white-space: nowrap;
      margin-left: auto;
      flex-shrink: 0;
    }
  }

  .empty-message {
    color: var(--color-text-secondary, #6b7280);
    font-size: 0.875rem;
    margin: 0.5rem 0 0;
  }
`;
